export default "__VITE_ASSET__7784b36e__"